<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              modalWidth="80%"
              :parentData="parentData"
              @action="masterAction"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de parametro')"
                        :formItemConfig="fiOptions"
                        :decorator="['param_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :selectedObj.sync="param_type"
                        :params="dynamic_load_param_type">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
              <a-input
                v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'},
              { type: 'string', validator: validateField }
              ]}]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Etiqueta')">
              <a-input
                v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions" v-show="esLovSql">
            <a-form-item v-bind="fiOptions" :label="$t('Parametro sql')">
              <a-textarea
                autoSize
                v-decorator="['param_sql', { rules: [{ required: isRequired, message: 'Valor requerido'}] }]">
              </a-textarea>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Requerido')" :has-feedback="false">
              <a-checkbox v-decorator="['required', {valuePropName: 'checked', initialValue: false}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Activo')" :has-feedback="false">
              <a-checkbox v-decorator="['active', {valuePropName: 'checked', initialValue: false}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-alert
            message="Información"
            type="info"
            show-icon
          >
            <template slot="description">
              <ul>
                <li>
                  El campo <strong>"Nombre"</strong> debe estar en minúscula. Este campo corresponde a
                  los parametros del proceso.
                </li>
                <li>
                  Si el tipo de parametro es <strong>"LOV_SQL"</strong> el campo
                  <strong>"Parametro sql"</strong> representa la consulta utilizada para generar la lista de valores.
                </li>
              </ul>
            </template>
          </a-alert>
        </a-row>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Parámetros" key="1">
        <dynamic-load-param-item v-if="dynamicLoadParams" :dynamic_load_param_id="dynamicLoadParams"/>
        <span v-else>Seleccione un parámetro de carga dinámica para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    props: ['dynamic_load_id'],
    data () {
      return {
        esLovSql: false,
        param_type: {},
        dynamic_load_param_type: {h_lookup_type: 'DYNAMIC_LOAD_PARAM_TYPE', use_code: true},
        isRequired: false,
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'dynamic_load_param',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Tipo de parametro', dataIndex: 'param_type', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Requerido', dataIndex: 'required_desc', sorter: true},
              {title: 'Active', dataIndex: 'active_desc', sorter: true},
              {title: 'Parametro sql', dataIndex: 'param_sql', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'param_type'},
            {name: 'name'},
            {name: 'required'},
            {name: 'label'},
            {name: 'param_sql'},
            {name: 'active'}
          ]
        }
      }
    },
    methods: {
      validateField (rule, value, callbackfn) {
        /* deebe terer una minus */
        let contieneMinus = (/[a-z]/.test(value)) && value === value.toLowerCase()
        if (!contieneMinus) {
          callbackfn('En nombre debe de ser en minúsculas')
        }
        callbackfn()
      },
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (action.changedFields.hasOwnProperty('param_type')) {
              this.isRequired = this.param_type.text === 'LOV_SQL'
            }
            break
          case 'masterCreate':
            this.esLovSql = false
            break

          case 'masterEdit':
            if (action.record.param_type === 'LOV_SQL') {
              this.esLovSql = true
            } else {
              this.esLovSql = false
            }
            break
        }
      }
    },
    computed: {
      parentData () {
        return {
          dynamic_load_id: this.dynamic_load_id
        }
      },
      dynamicLoadParams () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    },
    watch: {
      param_type () {
        if (this.param_type) {
          if (this.param_type.value === 'LOV_SQL') {
            this.esLovSql = true
          } else {
            this.esLovSql = false
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GDynamicLoads/DynamicLoadParams.vue